"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMCartApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class IMCartApiClient extends BaseApiClient_1.BaseApiClient {
    async getAvailableOrderSources() {
        const path = '/v1/cart/listall';
        const result = await this.request('GET', path);
        return result?.response ?? [];
    }
    async getAvailableOrderSource(id) {
        const path = `/v1/cart/listall/${id}`;
        const result = await this.request('GET', path);
        //IM returns an array with just the one channel asked for in it
        //I don't know why, but that's what they do so if we get an array
        //we'll just return the first object in it.
        if (Array.isArray(result?.response)) {
            return result?.response[0];
        }
        else {
            return result.response;
        }
    }
    async getConnections() {
        const path = `/v1/cart/list`;
        const result = await this.request('GET', path);
        return result?.response ?? [];
    }
    async getByOrderSource(orderSource, filter) {
        const path = `/v1/cart/list/${orderSource}`;
        const result = await this.request('GET', path, filter);
        return result.response;
    }
    async update(orderSource, body, filter) {
        const path = `/v1/cart/edit/${orderSource}`;
        const result = await this.request('POST', path, filter, body);
        return result.response;
    }
    async create(body) {
        const path = '/v1/cart/new';
        const result = await this.request('POST', path, undefined, body);
        return result.response;
    }
}
exports.IMCartApiClient = IMCartApiClient;
